import apiClient from "../Network/client";

/* =========================
   Types
========================= */
export interface FeatureDto {
  id: string;
  name: string;
  code: string;
  description: string | null;
}

interface FeaturesListResponse {
  success: boolean;
  message: string;
  data: {
    items: FeatureDto[];
    total: number;
    totalPages: number;
    itemsFrom: number;
    itemsTo: number;
    limit: number;
  };
}


export interface FeatureWithCompanyDto extends FeatureDto {
  enable: boolean;
}

interface FeaturesForCompanyResponse {
  success: boolean;
  message: string;
  data: {
    items: FeatureWithCompanyDto[];
    total?: number;
    totalPages?: number;
    itemsFrom?: number;
    itemsTo?: number;
    limit?: number;
  };
}

export interface CompanyFeatureStatusInput {
  featureId: string;
  enabled: boolean;
}

interface BulkUpdateResponse {
  success: boolean;
  message: string;
  data: FeatureDto[];
}


export const getAllFeatures = async (): Promise<FeatureDto[]> => {
  const res = await apiClient.get<FeaturesListResponse>("features");
  return res.data.data.items;
};


export const getFeaturesForCompany = async (
  companyId: string
): Promise<FeatureWithCompanyDto[]> => {
  const res = await apiClient.get<FeaturesForCompanyResponse>(
    `features/company/${companyId}`
  );
  const items = res.data?.data?.items;
  return Array.isArray(items) ? items : [];
};


export const updateCompanyFeatureStatuses = async (
  companyId: string,
  statuses: CompanyFeatureStatusInput[]
): Promise<FeatureDto[]> => {
  const res = await apiClient.put<BulkUpdateResponse>(
  `features/company/${companyId}`,
    statuses
  );
  return res.data.data;
};